export const RECAPTCHA_V2_KEY = '6LddT50mAAAAAPD7YlGPNzVeMDXCx_sk3GLp0_cX'
export const RECAPTCHA_V2_QA_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
export const RECAPTCHA_V3_KEY = '6LeF7RksAAAAANitD-IwCqh-eUQ4F_W6WG8L68Mn'
